import {
  ISOStringToLocalReadableTimestamp,
  shouldShowShipperCompanyName,
} from "../../../../utils";

const getShipmentPostedReadableDate = (
  shipment: CondensedShipment,
): string | null => {
  if (shipment?.info?.created_at) {
    return ISOStringToLocalReadableTimestamp(shipment.info.created_at);
  }
  return null;
};

const getPrivilegedSubheader = (shipment: CondensedShipment): string =>
  `Posted ${getShipmentPostedReadableDate(shipment) ?? "-"} by ${shipment?.shipment_company?.name ?? "-"}`;

const getUnprivilegedShipmentSubheader = (
  shipment: CondensedShipment,
): string => `Posted ${getShipmentPostedReadableDate(shipment) ?? "-"},`;

export const getShipmentSubheader = (
  shipment: CondensedShipment,
  isPartnerShipment: boolean,
  bookedByCarrier: boolean,
  isSubscribed: boolean,
) => {
  if (
    shouldShowShipperCompanyName({
      isSubscribed,
      isPartnerShipment,
      isBookedByCarrier: bookedByCarrier,
    })
  ) {
    return getPrivilegedSubheader(shipment);
  }
  return getUnprivilegedShipmentSubheader(shipment);
};
